/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreateComplaintRequest, CreateComplaintState } from "store/modules/complaints/types";

const initialState: CreateComplaintState = {
    isRequesting: false,
    successPayload: null,
    errors: []
};

const createComplaintSlice = createSlice({
    name: "complaints@createComplaint",
    initialState,
    reducers: {
        createComplaintRequest: (
            state,
            action: PayloadAction<CreateComplaintRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        createComplaintSuccess: (
            state,
            action: PayloadAction<null>
        ): void => {
            state.isRequesting = false;
            state.successPayload = action.payload;
        },
        createComplaintFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.successPayload = null;
            state.errors = action.payload;
        }
    }
});

export const {
    createComplaintRequest,
    createComplaintSuccess,
    createComplaintFailed
} = createComplaintSlice.actions;
export default createComplaintSlice.reducer;
